export const getVariant = (variantId, variants) => {
    return variants.find((variant) => {
        return variant.id === variantId
    })
}

export default getVariant